import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, deleteDataList, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { KSK2022_R01LotDto, KSK2022_R01Dto, KSK2022_R01HeaderDto, KSK2022_R01InspectDto, KSK2022_R01ProductResultDto, KSK2022_R01DetailDto, KSK2022_R01LotCountDto, KSK2022_R01WorkStandardDto } from './Dto_KSK2022_R01';
import { KSK2022_R01Filter } from "./Store_KSK2022_R01";

const baseUrl = `${config.apiUrl}/KSK2022_R01`;

const getParams = (filter: Partial<KSK2022_R01Filter>, listLength?: number) => {	
	return {
		labelPrintAuto: filter.labelPrintAuto || undefined,
		listLength: listLength || 0
	}
}

export const getKSK2022_R01List = async (option: string, params: Partial<KSK2022_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<KSK2022_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getKSK2022_R01AllCount = async (params: Partial<KSK2022_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

// PRD형: 작업지시번호 기준 단건 조회
export const getKSK2022_R01One = async (productOrderNo: string) => {
	const url = `${baseUrl}/one/${productOrderNo}`;
	return await getData<ResponseDto<KSK2022_R01HeaderDto>>(url);
}

export const getKSK2022_R01WorkStandardOne = async (itemCd: string, workplaceCd: string, sheetNo: 1 | 2) => {
	const url = `${baseUrl}/workStandard/${encodeURIComponent(itemCd)}/${encodeURIComponent(workplaceCd)}/${sheetNo}`;
	return await getData<ResponseDto<KSK2022_R01WorkStandardDto | null>>(url);
}

// PRD형: productResult/${productResultNo}
export const getKSK2022_R01ProductResultList = async (productResultNo: string) => {
	const url = `${baseUrl}/productResult/${productResultNo}`;
	return await getData<ResponseDto<KSK2022_R01ProductResultDto>>(url);
}

export const getKSK2022_R01LotList = async (itemCd: string) => {
	const url = `${baseUrl}/lot/${itemCd}`;

	return await getData<ResponseDto<KSK2022_R01LotDto[]>>(url);
}

export const getKSK2022_R01StockLot = async (productResultNo: string) => {
	const url = `${baseUrl}/lot/stock/${productResultNo}`;

	return await getData<ResponseDto<KSK2022_R01LotDto[]>>(url);
}

export const getKSK2022_R01LotCountOne = async (workplaceCd: string) => {
	const url = `${baseUrl}/lot/count/${workplaceCd}`;

	return await getData<ResponseDto<KSK2022_R01LotCountDto>>(url);
}

export const patchKSK2022_R01LotCount = async (workplaceCd: string, adjustmentQty: number) => {
	const url = `${baseUrl}/lot/count/${workplaceCd}`;

	return await patchData<Partial<KSK2022_R01LotCountDto>, ResponseDto<KSK2022_R01LotCountDto>>(url, {
		adjustmentQty,
	});
}

export const patchKSK2022_R01LotCountReset = async (workplaceCd: string) => {
	const url = `${baseUrl}/lot/count/${workplaceCd}/reset`;

	return await patchData<void, ResponseDto<KSK2022_R01LotCountDto>>(url);
}

export const postKSK2022_R01StockLot = async (data: KSK2022_R01Dto) => {
	const url = `${baseUrl}/lot/stock`;

	return await postData<KSK2022_R01Dto, ResponseDto<KSK2022_R01Dto>>(url, data);
}

export const getKSK2022_R01DetailList = async (productOrderNo: string, itemCd: string, productQty: number, badQty: number, outWarehouseCd: string, logicCenter: string, workplaceCd: string) => {
	const url = `${baseUrl}/detail`;

	return await getData<ResponseDto<KSK2022_R01DetailDto[]>>(url, { params: { 
			productOrderNo: productOrderNo,
			itemCd: itemCd,
			productQty: productQty,
			badQty: badQty,
			outWarehouseCd: outWarehouseCd,
			logicCenter: logicCenter,
			workplaceCd: workplaceCd
		} 
	});
}

export const getKSK2022_R01DetailStockList = async (productOrderNo: string, itemCd: string, outWarehouseCd: string, logicCenter: string) => {
	const url = `${baseUrl}/detail/stock`;

	return await getData<ResponseDto<KSK2022_R01DetailDto[]>>(url, { params: { 
			productOrderNo: productOrderNo,
			itemCd: itemCd,
			outWarehouseCd: outWarehouseCd,
			logicCenter: logicCenter
		} 
	});
}

export const getKSK2022_R01TransportedInfo = async (productResultNo: string) => {
	const url = `${baseUrl}/detail/transported`;
	return await getData<ResponseDto<KSK2022_R01DetailDto[]>>(url, {
		params: {
			productResultNo: productResultNo
		}
	});
}

export const getKSK2022_R01InspectList = async (productResultNo: string) => {
	const url = `${baseUrl}/inspect/${productResultNo}`;

	return await getData<ResponseDto<KSK2022_R01InspectDto[]>>(url);
}

export const postKSK2022_R01Inspect = async (data: KSK2022_R01Dto) => {
	const url = `${baseUrl}/inspect`;

	return await postData<KSK2022_R01Dto, ResponseDto<KSK2022_R01Dto>>(url, data);
}

export const deleteKSK2022_R01Inspect = async (data: KSK2022_R01Dto) => {
	const url = `${baseUrl}/inspect`;

	return await deleteDataList<KSK2022_R01Dto, ResponseDto<void>>(url, data);
}

export const createKSK2022_R01LotNo = async () => {
	const url = `${baseUrl}/lot/createLotNo`;
	return await getData<ResponseDto<string>>(url);
}

export const postKSK2022_R01 = async (data: KSK2022_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<KSK2022_R01Dto, ResponseDto<KSK2022_R01Dto>>(url, data);
}

export const patchKSK2022_R01 = async (data: KSK2022_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<KSK2022_R01Dto, ResponseDto<KSK2022_R01Dto>>(url, data);
}

// 키오스크 전용 — 식별키를 productOrderNo로 통일 (기존: productWorkNo)
export const patchKSK2022_R01WorkStart = async (productOrderNo: string, timeParam: string) => {
	const url = `${baseUrl}/workStart`;
	const data = { productOrderNo: productOrderNo, timeParam: timeParam } as KSK2022_R01HeaderDto;
	return await patchData<KSK2022_R01HeaderDto, ResponseDto<KSK2022_R01HeaderDto>>(url, data);
}

export const patchKSK2022_R01WorkEnd = async (productOrderNo: string, timeParam: string) => {
	const url = `${baseUrl}/workEnd`;
	const data = { productOrderNo: productOrderNo, timeParam: timeParam } as KSK2022_R01HeaderDto;
	return await patchData<KSK2022_R01HeaderDto, ResponseDto<KSK2022_R01HeaderDto>>(url, data);
}

export const deleteKSK2022_R01 = async (purchaseBillNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			purchaseBillNo
		}
	});
}

export const downloadExcel_KSK2022_R01 = async (option: string, purchaseBillNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			purchaseBillNo
		}
	})
}
export const printKSK2022_R01 = async (purchaseBillNo: string) => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
	  params: { purchaseBillNo },
	  responseType: "blob",
	});
	const fileBlob = new Blob([response.data], { type: "application/pdf" });
	const fileURL = URL.createObjectURL(fileBlob);
	window.open(fileURL, "_blank");
  };
